import React from 'react'

import { Portlet, Row, Col, Button } from '_zari/core'

import { ZariContext } from '_zari/context'

import { AdminContext } from 'contexts/AdminContext'

import * as JobService from 'services/job.service'

const ValorizarTodoOperacion = () => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const [iniciando, setIniciando] = React.useState(false)

  const clickValorizar = React.useCallback(() => {
    setIniciando(true)

    JobService.iniciarJob('VALORIZAR_TODO', { mes: __adminContext.mesTrabajo })
      .then(() => {
        __zariContext.snack('info', 'Valorización iniciada. Se notificará cuando termine.')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => setIniciando(false))
  }, [__zariContext, __adminContext])

  return (
    <Portlet>
      <Portlet.Header title='Valorizar Todo' />
      <Portlet.Body>
        <Row>
          <Col md={12} className='text-right'>
            <Button disabled={iniciando} onClick={clickValorizar}>
              Valorizar Todo
            </Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ValorizarTodoOperacion)
